// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3207":"ef355df3","4463":"2275fe1a","5253":"1d2dee91","7748":"262e7263"}[chunkId] + ".chunk.css";
};